import { createReducer, on } from "@ngrx/store"
import {  categoriesState } from "../homepage.state"
import * as homePageAction from '../action/fetch-categories.action';

const initialState: categoriesState = {
    categories: null,
    loading: false,
    success: false,
    error: false,
}

export const categoriesReducer = createReducer(
    initialState,
    on(homePageAction.fetchCategoriesAction, (state) => ({
        ...state,
        loading: true,
        success: false,
        error: false
    })),
    on(homePageAction.fetchCategoriesActionFail, (state, { payload }) => ({
        ...state,
        payload: payload,
        loading: false,
        success: false,
        error: true
    })),
    on(homePageAction.fetchCategoriesActionSuccess, (state, { categories }) => ({
        ...state,
        categories: categories,
        loading: false,
        success: true,
        error: false
    }))
)